import { Action } from '@ngrx/store'
import * as PdfBatchGenerationTypes from './pdf-batch-generation.types'
import { Settings } from './pdf-batch-generation.interface'

export class FetchPdfBatchStatsRequest implements Action {
  readonly type = PdfBatchGenerationTypes.FETCH_PDF_BATCH_STATS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchPdfBatchStatsSuccess implements Action {
  readonly type = PdfBatchGenerationTypes.FETCH_PDF_BATCH_STATS_SUCCESS
  constructor(public payload: Settings) {}
}

export class FetchPdfBatchStatsFailure implements Action {
  readonly type = PdfBatchGenerationTypes.FETCH_PDF_BATCH_STATS_FAILURE
  constructor(public payload: any) {}
}

export class FetchPdfBatchTaskStatusRequest implements Action {
  readonly type = PdfBatchGenerationTypes.FETCH_PDF_BATCH_TASK_STATUS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchPdfBatchTaskStatusSuccess implements Action {
  readonly type = PdfBatchGenerationTypes.FETCH_PDF_BATCH_TASK_STATUS_SUCCESS
  constructor(public payload: Settings) {}
}

export class FetchPdfBatchTaskStatusFailure implements Action {
  readonly type = PdfBatchGenerationTypes.FETCH_PDF_BATCH_TASK_STATUS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = PdfBatchGenerationTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = PdfBatchGenerationTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export class GeneratePdfBatchRequest implements Action {
  readonly type = PdfBatchGenerationTypes.GENERATE_PDF_BATCH_REQUEST
  constructor(public payload: any = {}) {}
}

export class GeneratePdfBatchSuccess implements Action {
  readonly type = PdfBatchGenerationTypes.GENERATE_PDF_BATCH_SUCCESS
  constructor(public payload: Settings) {}
}

export class GeneratePdfBatchFailure implements Action {
  readonly type = PdfBatchGenerationTypes.GENERATE_PDF_BATCH_FAILURE
  constructor(public payload: any) {}
}

export class StopPdfBatchGenerationRequest implements Action {
  readonly type = PdfBatchGenerationTypes.STOP_PDF_BATCH_GENERATION_REQUEST
  constructor(public payload: any = {}) {}
}

export class StopPdfBatchGenerationSuccess implements Action {
  readonly type = PdfBatchGenerationTypes.STOP_PDF_BATCH_GENERATION_SUCCESS
  constructor(public payload: Settings) {}
}

export class StopPdfBatchGenerationFailure implements Action {
  readonly type = PdfBatchGenerationTypes.STOP_PDF_BATCH_GENERATION_FAILURE
  constructor(public payload: any) {}
}

export type Actions =
  | FetchPdfBatchStatsSuccess
  | FetchPdfBatchStatsFailure
  | FetchPdfBatchStatsRequest
  | FetchPdfBatchTaskStatusRequest
  | FetchPdfBatchTaskStatusSuccess
  | FetchPdfBatchTaskStatusFailure
  | GeneratePdfBatchRequest
  | GeneratePdfBatchSuccess
  | GeneratePdfBatchFailure
  | StopPdfBatchGenerationRequest
  | StopPdfBatchGenerationSuccess
  | StopPdfBatchGenerationFailure
  | SetDefaultData
  | UpdateField
